import { useState, useEffect } from 'react'

export function useIsInIframe() {
  const [isInIframe, setIsInIframe] = useState(false)

  useEffect(() => {
    const inIframe = window.self !== window.top
    setIsInIframe(inIframe)
  }, [])

  return isInIframe
}
